import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { useMeetingAPIs } from "../../hooks/meeting";
import { PageMasterMode, usePageContext } from "../navigation/PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";
import { BaseTopBar } from "./BaseTopBar";
import { useCallback, useMemo } from "react";
import { isExpert } from "../../helpers/roles";
import { useAppStoreDispatch } from "../../contexts/appStore/context";
import { useMeetingSelector } from "@kalyzee/kast-web-sdk";

export interface MasterTopBarProps {
  onSettings?: () => void;
  onBack?: () => void;
  settingsBtnRef?: React.Ref<HTMLDivElement>;
}

export const MasterTopBar: React.FC<MasterTopBarProps> = ({
  onSettings,
  onBack,
  settingsBtnRef,
}) => {
  const dispatch = useAppStoreDispatch();
  const user = useAppStoreSelector(state => state.user);

  const pageContext = usePageContext<SessionMode.MASTER>();
  const pageContextRef = useRefAutoUpdate(pageContext);

  const { selectedContainerAPI } = useMeetingAPIs(pageContextRef.current?.params?.id);

  const [meetingId] = useMeetingSelector(selectedContainerAPI, "meeting", meeting => meeting?.id);
  const [meetingName] = useMeetingSelector(selectedContainerAPI, "meeting", meeting => meeting?.name);
  const [meetingStartedAt] = useMeetingSelector(selectedContainerAPI, "meeting", meeting => meeting?.startedAt);
  const [sessions] = useMeetingSelector(selectedContainerAPI, "sessions");

  const watchingNumber = useMemo(() => {
    return sessions?.filter(s => !isExpert(s)).length;
  }, [sessions]);

  const defaultOnBack = useCallback(() => {
    pageContextRef.current?.goTo(PageMasterMode.LIST);
    if (meetingId) {
      dispatch("setLastLeftMeetingId", meetingId);
    }
  }, [dispatch, meetingId]);

  const showDefaultOnBack = useMemo(() => ![PageMasterMode.LIST, PageMasterMode.LOGIN].includes(pageContextRef.current?.page!!), []);

  return (
    <BaseTopBar
      user={user}
      meetingName={meetingName}
      meetingStartedAt={meetingStartedAt}
      showDate={!meetingName} // show date if no meeting
      showLogo={true}
      onSettings={onSettings}
      onBack={onBack ?? (showDefaultOnBack ? defaultOnBack : undefined)}
      watchingNumber={watchingNumber}
      settingsBtnRef={settingsBtnRef}
    />
  );
}